module.exports = __webpack_public_path__ + "files/3dcba349f566fc787d061a186f000a37.svg";